import {RestRequestGET} from "libs/RestRequest";
import Endpoints from "constants/Endpoints";

const config = async () => {
    return await RestRequestGET(Endpoints.CUSTOMER_IO());
}

export default {
    config
}